import { InputType, Locale } from 'src/types'

export function getFilterFields(
  locale: Locale['maintenance']['historyMaintenance']['filters'],
) {
  const { maxOdometer, minOdometer, maxTotalCost, minTotalCost, serviceType } =
    locale.input

  return [
    { key: 'maxOdometer', type: InputType.NUMBER, placeholder: maxOdometer },
    { key: 'minOdometer', type: InputType.NUMBER, placeholder: minOdometer },
    { key: 'serviceType', type: InputType.SELECT, placeholder: serviceType },
    { key: 'maxTotalCost', type: InputType.NUMBER, placeholder: maxTotalCost },
    { key: 'minTotalCost', type: InputType.NUMBER, placeholder: minTotalCost },
  ] as const
}
